import React, { Component } from 'react'
import AboutLeft from './AboutLeft'
import AboutRight from './AboutRight'
import './style.css'

export default class About extends Component {


    componentDidMount() {




    }

    render() {



        return (

            <React.Fragment>
                <AboutLeft />
                <AboutRight />

            </React.Fragment>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/about/index.js